import { render, staticRenderFns } from "./VerifiyCountries.vue?vue&type=template&id=52b5c4b6&scoped=true"
import script from "./VerifiyCountries.vue?vue&type=script&lang=js"
export * from "./VerifiyCountries.vue?vue&type=script&lang=js"
import style0 from "./VerifiyCountries.vue?vue&type=style&index=0&id=52b5c4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5c4b6",
  null
  
)

export default component.exports